import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import './style.scss';
import {setAnnouncementsHidden} from 'store/entities/announcement';
import {sanitizeHtml} from 'utils/stringUtils';
import {IconButton} from '../../UIComponents/Button';
import {mdiChevronDown, mdiClose, mdiInformationOutline} from '@mdi/js';
import Icon from '@mdi/react';

const Announcements = () => {
  const dispatch = useDispatch();
  const {
    announcements,
    announcementsHidden
  } = useSelector(state => state.announcement);

  return (
    <>
      {!!announcements.length && (
        <>
          <div className="announcement-container">
            <div className="announcement-icon-col">
              <Icon path={mdiInformationOutline} size={1.4}/>
            </div>
            <div className={"announcement-col " + (announcementsHidden ? "announcement-hidden" : "")}>
              {announcements.map((row, i) => {
                return (
                  <div key={i} className="announcement-row">
                    <strong>
                      {row.title}
                    </strong>
                    <p dangerouslySetInnerHTML={{__html: sanitizeHtml(row.content)}}></p>
                  </div>
                );
              })}
            </div>
            <div className="announcement-actions-col">
              {announcementsHidden ? (
                <IconButton
                  path={mdiChevronDown}
                  size={1.4}
                  type="button"
                  aria-label="Show announcements"
                  aria-haspopup="dialog"
                  onClick={() => dispatch(setAnnouncementsHidden(false))}
                />
              ) : (
                <IconButton
                  path={mdiClose}
                  size={1.2}
                  type="button"
                  aria-label="Hide announcements"
                  aria-haspopup="dialog"
                  onClick={() => dispatch(setAnnouncementsHidden(true))}
                />
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Announcements;
